import {HELPED_FRAGMENTS} from '../enums/enums';
import {replaceSquareBrackets} from './replaceSquareBrackets';
import {getAliasName} from './getAliasName';
import {getHash} from './getHash';
import {getUserData} from './getUserData';

export const getFormData = (buttonElement, formElement, objects) => {
  let userData = {};
  const formInputs = formElement.querySelectorAll(HELPED_FRAGMENTS.FORM_INPUT_IDENTIFIER);

  if (formInputs) {
    for (const input of formInputs) {
      const inputIdentifier = input.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_INPUT_IDENTIFIER));

      if (input && input.value) {
        const inputIdentifierKey = getAliasName(inputIdentifier);

        if (inputIdentifierKey) {
          userData = {
            ...userData,
            [inputIdentifierKey]: getHash(input.value)
          };
        }
      }
    }
    ;
  }

  const formId = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_FORM_ID));
  const formName = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_FORM_NAME));
  const formText = buttonElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_SUBMIT_FORM_TEXT));

  const formData = {
    id: formId,
    name: formName,
    text: formText
  };

  return {
    form: formData,
    ...getUserData(objects, userData)
  };
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getFormData.js